import React from 'react';

import { mdiTextBoxOutline, mdiGoogleCirclesExtended } from '@lumapps/lumx/icons';
import { NavigationItemType, NavigationMapPageReferenceType } from '@lumapps/navigation/types';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { NAVIGATION_ADMIN } from '../../keys';
import { NavigationNodeDetailsError } from './NavigationNodeDetailsError';

interface UnavailableNavigationItemDetailsProps {
    pageType?: NavigationMapPageReferenceType;
}

/**
 *  Unavailable Node. It is displayed when the linked resource is not available (e.g. sync delay or deleted content)
 */
export const UnavailableNavigationItemDetails: React.FC<UnavailableNavigationItemDetailsProps> = ({ pageType }) => {
    const { translateKey } = useTranslate();

    return (
        <NavigationNodeDetailsError
            icon={pageType === NavigationItemType.CONTENT ? mdiTextBoxOutline : mdiGoogleCirclesExtended}
            title={translateKey(
                pageType === NavigationItemType.COMMUNITY ? GLOBAL.UNAVAILABLE_COMMUNITY : GLOBAL.UNAVAILABLE_CONTENT,
            )}
            description={translateKey(NAVIGATION_ADMIN.ITEM_WILL_NOT_APPEAR_IN_NAVIGATION)}
        />
    );
};
